module.exports = __webpack_public_path__ + "img/horizontal_3_2_8023.6d3512c1.png";